/** Merge into `companyOverview` in each locale. */
export const companyOverviewCopy = {
  en: {
    quickActions: {
      title: 'Quick actions',
      description: 'Create, manage and organize your work.',
      newPresentation: 'New presentation',
      newPresentationHint: 'Start a new story',
      newProject: 'New project',
      newProjectHint: 'Organize related work',
      uploadAssets: 'Upload assets',
      uploadAssetsHint: 'Images, video, audio',
      browseTemplates: 'Browse templates',
      browseTemplatesHint: 'Start from a template',
      inviteMembers: 'Invite members',
      inviteMembersHint: 'Collaborate with your team',
    },
    statHints: {
      inReview_one: '{{count}} in review',
      inReview_other: '{{count}} in review',
    },
    openPresentation: 'Open {{name}}',
    noProjectsNoAccess:
      'You do not have access to a project yet. Ask a company owner or admin to add you to one.',
    projectsPanel: {
      title: 'Projects',
      presentations_one: '{{count}} presentation',
      presentations_other: '{{count}} presentations',
      open: 'Open {{name}}',
      settings: 'Project settings for {{name}}',
    },
    attention: {
      title: 'Needs attention',
      inReview_one: '{{count}} presentation in review',
      inReview_other: '{{count}} presentations in review',
      review: 'Review',
    },
    shareLinks: {
      title: 'Share links',
      active_one: '{{count}} active share link',
      active_other: '{{count}} active share links',
      none: 'No active share links',
      hint: 'Manage links from each presentation’s Shares tab.',
    },
    quickAccess: {
      title: 'Quick access',
      assets: 'Assets',
      templates: 'Templates',
      settings: 'Company settings',
    },
    activityPhrase: '{{actor}} {{label}}',
    activity: {
      ai_proposal_approved: 'approved an AI proposal',
      ai_proposal_build_failed: 'had an AI proposal fail to build',
      ai_proposal_built: 'built an AI proposal',
      ai_proposal_rejected: 'rejected an AI proposal',
      ai_proposal_submitted: 'submitted an AI proposal',
      asset_upload_completed: 'uploaded an asset',
      comment_updated: 'updated a comment',
      company_ai_provider_configured: 'configured the AI provider',
      company_ai_provider_removed: 'removed the AI provider',
      company_ai_provider_rotated: 'rotated the AI provider key',
      company_ai_provider_tested: 'tested the AI provider',
      company_settings_updated: 'updated company settings',
      external_identity_linked: 'linked an external identity',
      external_identity_unlinked: 'unlinked an external identity',
      member_access_changed: 'changed a member’s access',
      member_invitation_accepted: 'accepted an invitation',
      member_invitation_resent: 'resent an invitation',
      member_invitation_revoked: 'revoked an invitation',
      member_invited: 'invited a member',
      member_removed: 'removed a member',
      member_template_capabilities_changed: 'changed a member’s template permissions',
      narration_generation_completed: 'finished generating narration',
      narration_generation_failed: 'had narration generation fail',
      narration_generation_requested: 'requested narration',
      presentation_access_changed: 'changed presentation access',
      presentation_access_removed: 'removed presentation access',
      presentation_appearance_updated: 'updated a presentation’s appearance',
      presentation_created: 'created a presentation',
      presentation_deleted: 'deleted a presentation',
      presentation_duplicated: 'duplicated a presentation',
      presentation_publish_requested: 'requested a publish',
      presentation_published: 'published a presentation',
      presentation_share_link_created: 'created a share link',
      presentation_share_link_revoked: 'revoked a share link',
      presentation_share_link_updated: 'updated a share link',
      project_access_changed: 'changed project access',
      project_access_removed: 'removed project access',
      project_created: 'created a project',
      project_deleted: 'deleted a project',
      project_design_kit_updated: 'updated a project design kit',
      project_updated: 'updated a project',
      template_draft_approved: 'approved a template draft',
      template_draft_published: 'published a template',
      template_draft_rejected: 'rejected a template draft',
      template_draft_revised: 'revised a template draft',
      template_fork_created: 'forked a template',
      theme_version_created: 'published a theme version',
    },
  },
  fa: {
    quickActions: {
      title: 'دسترسی سریع',
      description: 'کارهایتان را بسازید، مدیریت و سازمان‌دهی کنید.',
      newPresentation: 'ارائه جدید',
      newPresentationHint: 'یک داستان تازه آغاز کنید',
      newProject: 'پروژه جدید',
      newProjectHint: 'کارهای مرتبط را سازمان دهید',
      uploadAssets: 'بارگذاری دارایی',
      uploadAssetsHint: 'تصویر، ویدیو، صدا',
      browseTemplates: 'مرور قالب‌ها',
      browseTemplatesHint: 'از یک قالب شروع کنید',
      inviteMembers: 'دعوت اعضا',
      inviteMembersHint: 'با تیمتان همکاری کنید',
    },
    statHints: {
      inReview: '{{count}} در حال بازبینی',
    },
    openPresentation: 'باز کردن {{name}}',
    noProjectsNoAccess:
      'هنوز به هیچ پروژه‌ای دسترسی ندارید. از مالک یا مدیر شرکت بخواهید شما را به یک پروژه اضافه کند.',
    projectsPanel: {
      title: 'پروژه‌ها',
      presentations: '{{count}} ارائه',
      open: 'باز کردن {{name}}',
      settings: 'تنظیمات پروژه {{name}}',
    },
    attention: {
      title: 'نیازمند توجه',
      inReview: '{{count}} ارائه در حال بازبینی',
      review: 'بازبینی',
    },
    shareLinks: {
      title: 'پیوندهای اشتراک',
      active: '{{count}} پیوند اشتراک فعال',
      none: 'پیوند اشتراک فعالی نیست',
      hint: 'پیوندها را از تب اشتراک‌گذاری هر ارائه مدیریت کنید.',
    },
    quickAccess: {
      title: 'دسترسی سریع',
      assets: 'دارایی‌ها',
      templates: 'قالب‌ها',
      settings: 'تنظیمات شرکت',
    },
    activityPhrase: '{{actor}} {{label}}',
    activity: {
      ai_proposal_approved: 'یک پیشنهاد هوش مصنوعی را تأیید کرد',
      ai_proposal_build_failed: 'ساخت یک پیشنهاد هوش مصنوعی ناموفق بود',
      ai_proposal_built: 'یک پیشنهاد هوش مصنوعی را ساخت',
      ai_proposal_rejected: 'یک پیشنهاد هوش مصنوعی را رد کرد',
      ai_proposal_submitted: 'یک پیشنهاد هوش مصنوعی را ارسال کرد',
      asset_upload_completed: 'یک دارایی بارگذاری کرد',
      comment_updated: 'نظری را به‌روزرسانی کرد',
      company_ai_provider_configured: 'ارائه‌دهنده هوش مصنوعی را تنظیم کرد',
      company_ai_provider_removed: 'ارائه‌دهنده هوش مصنوعی را حذف کرد',
      company_ai_provider_rotated: 'کلید ارائه‌دهنده هوش مصنوعی را تعویض کرد',
      company_ai_provider_tested: 'ارائه‌دهنده هوش مصنوعی را آزمود',
      company_settings_updated: 'تنظیمات شرکت را به‌روزرسانی کرد',
      external_identity_linked: 'یک هویت خارجی را متصل کرد',
      external_identity_unlinked: 'اتصال یک هویت خارجی را قطع کرد',
      member_access_changed: 'دسترسی یک عضو را تغییر داد',
      member_invitation_accepted: 'یک دعوت‌نامه را پذیرفت',
      member_invitation_resent: 'یک دعوت‌نامه را دوباره فرستاد',
      member_invitation_revoked: 'یک دعوت‌نامه را لغو کرد',
      member_invited: 'عضوی را دعوت کرد',
      member_removed: 'عضوی را حذف کرد',
      member_template_capabilities_changed: 'مجوزهای قالب یک عضو را تغییر داد',
      narration_generation_completed: 'تولید روایت را به پایان رساند',
      narration_generation_failed: 'تولید روایت ناموفق بود',
      narration_generation_requested: 'تولید روایت را درخواست کرد',
      presentation_access_changed: 'دسترسی یک ارائه را تغییر داد',
      presentation_access_removed: 'دسترسی یک ارائه را حذف کرد',
      presentation_appearance_updated: 'ظاهر یک ارائه را به‌روزرسانی کرد',
      presentation_created: 'یک ارائه ساخت',
      presentation_deleted: 'یک ارائه را حذف کرد',
      presentation_duplicated: 'یک ارائه را تکثیر کرد',
      presentation_publish_requested: 'درخواست انتشار ثبت کرد',
      presentation_published: 'یک ارائه را منتشر کرد',
      presentation_share_link_created: 'یک پیوند اشتراک ساخت',
      presentation_share_link_revoked: 'یک پیوند اشتراک را لغو کرد',
      presentation_share_link_updated: 'یک پیوند اشتراک را به‌روزرسانی کرد',
      project_access_changed: 'دسترسی یک پروژه را تغییر داد',
      project_access_removed: 'دسترسی یک پروژه را حذف کرد',
      project_created: 'یک پروژه ساخت',
      project_deleted: 'یک پروژه را حذف کرد',
      project_design_kit_updated: 'کیت طراحی یک پروژه را به‌روزرسانی کرد',
      project_updated: 'یک پروژه را به‌روزرسانی کرد',
      template_draft_approved: 'یک پیش‌نویس قالب را تأیید کرد',
      template_draft_published: 'یک قالب را منتشر کرد',
      template_draft_rejected: 'یک پیش‌نویس قالب را رد کرد',
      template_draft_revised: 'یک پیش‌نویس قالب را بازنگری کرد',
      template_fork_created: 'یک انشعاب از قالب ساخت',
      theme_version_created: 'نسخه‌ای از تم منتشر کرد',
    },
  },
} as const;

/** "presentation.share_link.updated" becomes "presentation share link updated" (fallback label). */
export function humanizeAuditAction(action: string): string {
  return action.replaceAll(/[._]+/gu, ' ').trim().toLowerCase();
}

/** i18n key segment for an audit action; `.` is the key separator so it is flattened. */
export function auditActionKey(action: string): string {
  return action.replaceAll('.', '_');
}
